{
  "toasts": {
    "create_error": "Error creating label",
    "update_error": "Error updating label",
    "delete_error": "Error deleting label",
    "exists_error": "This label already exists"
  },
  "label": {
    "title": "Labels",
    "empty_cta": "Add labels by clicking the"
  },
  "who": {
    "title": "Who label",
    "empty_cta": "Add WHO labels by clicking the",
    "reorder_tag_aria_label": "Drag to reorder Who tags",
    "create_help": "Hit enter to save"
  },
  "placeholder": "Start typing…",
  "validate_required": "Text is required",
  "edit": "Edit",
  "delete": "Delete",
  "manage": "Manage",
  "create": "Create a new label"
}
